import { StorageContainer } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface ActivateStorageContainerMutation {
  activateStorageContainer: StorageContainer
}

export interface ActivateStorageContainerVariables {
  id: GQL_ID
}

export const GQL_MUTATION_ACTIVATE_STORAGE_CONTAINER = gql`
  mutation activateStorageContainer($id: ID!) {
    activateStorageContainer(id: $id) {
      id
      container_id
      size
      type
      description
      is_active
      created_at
      updated_at
      displayName
    }
  }
`

export function useActivateStorageContainer () {
  return useMutation<ActivateStorageContainerMutation, ActivateStorageContainerVariables>(
    GQL_MUTATION_ACTIVATE_STORAGE_CONTAINER
  )
}
